import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { AuthCard, AuthLayout } from "components/views/login/Shared"
import React, { useEffect } from "react"
import L10n from "lib/carrot-l10n"
import { useHistory } from "react-router"
import { useSignUpFlow } from "../context/signup/SignUpFlowContext"
import { H1 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export default function SignUpGetHelpSuccessPage() {
  const { email } = useSignUpFlow()
  const history = useHistory()

  useEffect(() => {
    if (!email) {
      history.push("/signup")
    }
  }, [])

  return (
    <AuthLayout title="We're on it">
      <AuthCard>
        <Spacer height={4} />
        <FlexRowCenter>
          <H1>{l`We're on it`}</H1>
        </FlexRowCenter>
        <Spacer height={0.5} />
        <Body color="black-80" align="tc">
          {l`Our Care Team is on the case and will reach out to you at `}
          {email}.
        </Body>
        <Spacer height={2} />
      </AuthCard>
    </AuthLayout>
  )
}
